import React from "react";
import LoadingStatus from "../../constants/loadingStatus";

// eslint-disable-next-line
const withShimmer = (component, Shimmer, status) => {
  return status === LoadingStatus.loaded ? component : <Shimmer />;
};

export default withShimmer;
